import React from 'react';
import SEO from '../components/SEO';

export default function AntiRacismPage() {
  return (
    <div data-testid="anti-racism-page">
      <SEO
        title="Anti-Racism Policy"
        description="Glossop & District Round Table 916's commitment to opposing all forms of racism and ensuring a safe, welcoming environment for everyone."
        path="/policies/anti-racism"
        keywords={['anti-racism policy', 'equality', 'Glossop Round Table policy', 'inclusion']}
      />

      <div className="pt-28 sm:pt-32 pb-20 sm:pb-28 bg-white min-h-screen">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <span className="text-sm uppercase tracking-[0.2em] font-bold text-[#F0A500] block mb-4">Equality & Inclusion</span>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#0A0A0A] mb-8">
            Anti-Racism Policy
          </h1>

          <div className="space-y-8 text-base text-[#52525B] leading-relaxed">
            <div>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-4">Our Commitment</h2>
              <p className="mb-4">
                Glossop & District Round Table is firmly opposed to all forms of racism.
              </p>
              <p className="mb-4">
                We are a social group for men aged 18-45 who volunteer our time to raise funds for local charities and good causes. We want all members, volunteers, partner groups and members of the public to feel safe, welcome and respected at our events and activities.
              </p>
              <p>
                This policy is informed by the Equality Act 2010 (protection from race discrimination, harassment and victimisation) and the Human Rights Act 1998 (right to dignity and non-discrimination).
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-4">Who This Policy Applies To</h2>
              <p className="mb-4">This policy applies to:</p>
              <ul className="list-disc pl-6 space-y-2 mb-4">
                <li>All Round Table members, officers and trustees</li>
                <li>Anyone volunteering at our events (including members of the public and local groups)</li>
                <li>Our interactions with beneficiaries, sponsors, venues and the wider community</li>
              </ul>
              <p>
                It covers all activities run in the name of Glossop & District Round Table, whether in person or online.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-4">Our Approach to Racism</h2>
              <p className="mb-4 font-semibold text-[#0A0A0A]">We will not tolerate:</p>
              <ul className="list-disc pl-6 space-y-2 mb-6">
                <li>Racist language, jokes, slurs or stereotypes</li>
                <li>Racist behaviour, exclusion or "banter" that targets someone's race, colour, nationality, or ethnic or national origins</li>
                <li>Any harassment or victimisation of someone who raises a concern about racism</li>
              </ul>
              <p className="mb-4 font-semibold text-[#0A0A0A]">All members and volunteers are expected to:</p>
              <ul className="list-disc pl-6 space-y-2 mb-6">
                <li>Treat everyone with dignity and respect</li>
                <li>Challenge or report racist behaviour they see or hear at Round Table activities</li>
                <li>Support a culture where everyone feels able to speak up</li>
              </ul>
              <p>
                We may choose not to work with, or may ask to leave, any individual, group or organisation whose behaviour is clearly racist or undermines this policy.
              </p>
            </div>

            <div className="p-6 bg-[#F4F4F5] border-l-4 border-[#F0A500]">
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-4">Raising Concerns</h2>
              <p className="mb-4">
                If you experience or witness racism at a Round Table meeting or event, you are encouraged to:
              </p>
              <ul className="list-disc pl-6 space-y-2 mb-6">
                <li>Speak to an officer of the Table (e.g. Chair, Vice Chair, Secretary) or</li>
                <li>Speak to any member you feel comfortable with, who can pass the concern to an officer</li>
              </ul>
              <p className="mb-4 font-semibold text-[#0A0A0A]">Concerns will be:</p>
              <ul className="list-disc pl-6 space-y-2 mb-6">
                <li>Taken seriously and handled sensitively</li>
                <li>Discussed by the officers to decide on fair and proportionate action</li>
                <li>Used to improve how we organise and run future events</li>
              </ul>
              <p className="mb-4">Where behaviour is serious, persistent or potentially criminal, we may:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Ask individuals to leave an event or not to return, and/or</li>
                <li>Report matters to relevant authorities if appropriate</li>
              </ul>
            </div>

            <div>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-4">Events and Volunteers</h2>
              <p className="mb-4">When planning and running events, we will aim to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Make it clear that racism and abusive behaviour are not acceptable</li>
                <li>Brief volunteers and partner groups that we expect respectful behaviour towards all</li>
                <li>Step in quickly if we see or hear racist comments, behaviour or abuse</li>
              </ul>
            </div>

            <div>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-4">Review</h2>
              <p>
                This policy will be reviewed by the officers of Glossop & District Round Table at least every two years, or sooner if an incident or change in guidance suggests we should update it.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
